<template>
  <div class="setting_content">
    <div class="setting_content_main">
      <div class="setting_content_heading">
        <div class="setting_content_heading_btn">
          <button
            class="setting_btn_secondary setting_btn_medium"
            @click="updateRedisData"
          >
            {{ labelProperties.BUTTON_UPDATE_REDIS_DATA }}
          </button>
        </div>
      </div>
      <div class="setting_content_heading_btn mt-3">
        <button class="setting_btn_secondary setting_btn_medium" @click="resetMasterData">
          {{ labelMasterProperties.BUTTON_RESET_MASTER_DATA }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import labelProperties from "../../../../properties/job_information/job_information_tab/job-information-labels.json";
import labelMasterProperties from "../../../../properties/master_screen/master-labels.json";

export default {
  name: "JobInformationTab",
  data: function () {
    return {
      labelProperties: labelProperties,
      labelMasterProperties: labelMasterProperties
    };
  },
  methods: {
    updateRedisData(){
       this.$emit("updateRedisData");
    },

    resetMasterData(){
      this.$emit("resetMasterData");
    }
  },
};
</script>
